<template>

    <div class="py-3">
        <div class="d-flex justify-content-between mb-3">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isData ? '#' : '/settings/user'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg" />
                Create User
            </router-link>
            <SaveBtn @save="submitHandler" />
        </div>

        <div id="createUserContainer" class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between">
                <div class="row col-12">
                    <div class="col-md-4">
                        <label for="inputName" class="form-label">Name</label>
                        <div class="d-flex mb-1">
                            <input type="text"
                                @input="[changeHandler($event, errors, 'name'), setData($event, 'name'), validateInput($event)]"
                                v-model="userData.name" class="custom-input form-control" id="inputName"
                                placeholder="Name"
                                :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                        </div>

                        <div class="err position-absolute" v-if="errors['name'].length > 0">
                            <div v-for="msg in errors['name']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="inputEmail" class="form-label">Email</label>
                        <div class="d-flex flex-nowrap  mb-1">
                            <input type="email"
                                @input="[changeHandler($event, errors, 'email'), setData($event, 'email')]"
                                v-model="userData.email" class="custom-inputForEmail form-control" id="inputEmail"
                                placeholder="Email"
                                :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                            <div class="input-group-append">
                                <span class="input-group-text">@{{ organziationDomain }}</span>
                            </div>
                        </div>
                        <div class="err" v-if="errors['email'].length > 0">
                            <div v-for="msg in errors['email']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 d-flex ">
                    <div class="col-md-4 ">
                        <label class="mb-2">Password</label>
                        <input type="password" class="form-control custom-input" v-model="userData.password"
                            @input="[changeHandler($event, errors, 'password'), setData($event, 'password')]"
                            id="password" name="password" placeholder="Enter Password">

                        <div class="err" v-if="errors['password'].length > 0">
                            <div v-for="msg in errors['password']" class="text-danger">{{ msg }}<br></div>
                        </div>
                    </div>
                    <div class="col-md-4 ">
                        <label class="mb-2">Confirm Password</label>
                        <input type="password" class="form-control custom-input"
                            v-model="userData.password_confirmation"
                            @input="[changeHandler($event, errors, 'password_confirmation'), setData($event, 'password_confirmation')]"
                            id="password_confirmation" name="password_confirmation" placeholder="Confirm Password">

                        <div class="err" v-if="errors['password_confirmation'].length > 0">
                            <div v-for="msg in errors['password_confirmation']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 d-flex">
                    <div class="col-md-4">
                        <div class="divMultiSelect">
                            <label class="form-label">Assign Role</label>
                            <Multiselect v-model="userData.userRoles" :options="roles" class="custom-input"
                                placeholder="Assign Role to User"
                                :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }" />
                            <span class="fontInfoData">
                                <font-awesome-icon @mouseover="showDefaultUser" @mouseleave="hideDefaultUser"
                                    class="styleDesignCircleInfo" :icon="['fas', 'circle-info']" size="lg" />
                            </span>
                            <span id="defaultUser" class="designDefaultUser">The user role is designated for users whom
                                their role is to
                                attend trainings and competitions only, and thwy will not have any administration role,
                                like creating templates and competitions</span>
                        </div>
                    </div>
                </div>

                <div class="row col-md-12 cssGap">
                    <div class="hrAll">
                        <hr class="new1 col-md-4">
                        &nbsp;&nbsp;&nbsp;
                        <span>OR</span>
                        &nbsp;&nbsp;&nbsp;
                        <hr class="new2 col-md-4">
                    </div>

                    <div class="col-md-4">
                        <label>Upload User List</label>
                        <div class="upload-file2"
                            :class="{ 'upload-container': isDownloaded, 'upload-container-none': !isDownloaded }"
                            :style="((userData.name != '') || (userData.email != '')) ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                            <FilePondDemo @fileRemove="fileRemove" @fileUpload="fileUpload"
                                accepted="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                :allowMultiple="false"
                                content='<div class=""><svg xmlns="http://www.w3.org/2000/svg" width="40" height="53.751" viewBox="0 0 53.326 53.751">
                                                                 <path id="Icon_awesome-file-import" data-name="Icon awesome-file-import" d="M1.666,30.235A1.678,1.678,0,0,0,0,31.915v3.359a1.678,1.678,0,0,0,1.666,1.68H13.332V30.235ZM52.6,11.023,42.4.735A2.488,2.488,0,0,0,40.63,0h-.635V13.438H53.326V12.8A2.522,2.522,0,0,0,52.6,11.023ZM36.662,14.278V0H15.831a2.5,2.5,0,0,0-2.5,2.52V30.235H26.663V23.39A1.669,1.669,0,0,1,29.517,22.2l9.957,10.131a1.8,1.8,0,0,1,0,2.52l-9.967,10.12a1.669,1.669,0,0,1-2.854-1.186V36.954H13.332V51.231a2.5,2.5,0,0,0,2.5,2.52h35a2.5,2.5,0,0,0,2.5-2.52V16.8H39.161A2.517,2.517,0,0,1,36.662,14.278Z" fill="#e95626"/>
                                                            </svg><div class="my-3">Drag & Drop Users File Here</div></div>' />
                        </div>
                    </div>

                    <div class="col-md-4 checkPositionRelative">
                        <label class="mb-1">Assign Role</label>
                        <Multiselect v-model="userData.userRoles2" :options="roles2" class="custom-input"
                            placeholder="Assign Role to User"
                            :style="((userData.name != '') || (userData.email != '')) ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }" />
                        <br>
                        <br>
                        <label>Download template of users, fill it, and upload to your list</label>
                        <div class="upload-file pt-4">
                            <div class="imgNew" @click.prevent="viewDocumentHandler" style="cursor: pointer;">
                                <img src="../../../assets/images/downloadExcel.png" alt=""> &nbsp;&nbsp; <span
                                    style="color: #e95626;position:relative;top:3px;">Download Excel Template</span>
                            </div>
                        </div>
                    </div>

                </div>
            </form>

            <div v-if="errorMessages.length > 0" class="error-container">
                <div v-for="msg in errorMessages" class="text-danger my-4">{{ msg }}</div>
            </div>
        </div>
    </div>

    <AlartModal v-if="showModal" message="User Created" imagePath="okImage.svg" @close-modal="showModal = false" />
    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
        @close-modal="showErrorModal = false" />

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
        @close-modal="confirmModalHandler($event)" />
</template>
<script>
import FilePondDemo from '../../components/FilePondDemo';
import SaveBtn from '../../components/SaveBtn';
import User from '../../../api-services/repository'
import { computed, defineAsyncComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import router from "../../../router";
import { useRoute } from "vue-router";
import Multiselect from '@vueform/multiselect';

import changeHandler from '../../../validation/userValidation';

import repository from "../../../api-services/repository";

const ConfirmationModal = defineAsyncComponent(() =>
    import('../../components/ConfirmationModal')
);
const AlartModal = defineAsyncComponent(() =>
    import('../../components/AlartModal')
);
export default {
    name: 'app',
    components: { FilePondDemo, AlartModal, SaveBtn, ConfirmationModal, Multiselect },
    setup() {
        const store = useStore();
        const route = useRoute();
        const backBtn = ref(null);
        const isErrorTag = ref(false);
        const ownerID = store.state?.auth?.user ? store.state?.auth?.user.data.id : null;
        const showModal = ref(false);
        const isFull = ref(false);
        const organziationDomain = ref(false);
        const isDownloaded = ref(false);
        const backURL = ref('#');
        const showErrorModal = ref(false);
        const roles = ref([]);
        const roles2 = ref([]);
        const userData = ref({
            owner_id: ownerID,
            name: '',
            email: '',
            userRoles: null,
            userRoles2: null,
            password: null,
            password_confirmation: null,
            file: null
        });

        let errors = ref({
            name: [],
            UserEmail: [],
            email: [],
            password: [],
            password_confirmation: [],
            isError: false
        });

        let isData = ref({
            name: false,
            UserEmail: false,
            file: false,
            password: false,
            password_confirmation: false,
        });


        const errorMessages = ref([]);
        const responseErrorMessage = ref('');

        onMounted(async () => {
            await store.dispatch('activeTap', 'settings');
            const responseDomain = await repository.getOrganization();
            organziationDomain.value = responseDomain.data;
            const response = await repository.getRoles();
            for (let i = 0; i < response.data.data.length; i++) {
                roles.value.push({ label: response.data.data[i].name === 'user' ? 'Default User' : response.data.data[i].name.replace(/[0-9]/g, ''), value: response.data.data[i].name });
                roles2.value.push({ label: response.data.data[i].name === 'user' ? 'Default User' : response.data.data[i].name.replace(/[0-9]/g, ''), value: response.data.data[i].name });
            }
        });

        const viewDocumentHandler = async (e, filePath) => {
            const link = document.createElement("a");
            link.href = "https://dk703uarlyapi.cloudfront.net/users-demo.xlsx";
            link.download = "users_demo.xlsx";
            link.click();

            isDownloaded.value = true
        };

        const showDefaultUser = () => {
            let message = document.getElementById('defaultUser');
            message.style.display = 'block';
        };

        const hideDefaultUser = () => {
            let message = document.getElementById('defaultUser');
            message.style.display = 'none';
        };

        const fileUpload = (event) => {
            userData.value.file = event['file'];
            setData(true, 'file');
        };

        const fileRemove = (event) => {
            userData.value.file = null;
            setData('', 'file');
        };

        const setData = (e, type) => {
            let val = type !== 'file' ? e.target.value : e;
            let uploadFile = document.getElementsByClassName('upload-file');
            console.log(isData.value[type], "*******")
            if (val !== '') {
                isData.value[type] = true;

                if (type === 'file') {
                    errors.value['name'] = [];
                    errors.value['UserEmail'] = [];
                }
            } else {
                isData.value[type] = false;
            }

            if (isData.value[type]) {
                store.dispatch('setDataFlag', true);
            }
            if (type === 'password') {
                if (val !== '') {
                    isData.password = true;
                } else {
                    isData.password = false;
                }
            }

            if (type === 'password_confirmation') {
                if (val !== '') {
                    isData.password_confirmation = true;
                } else {
                    isData.password_confirmation = false;
                }
            }
            if (isData.password || isData.password_confirmation) {
                store.dispatch('setDataFlag', true);
                console.log('data ==>> ')
            }
            else {
                store.dispatch('setDataFlag', false);
            }

        };

        const validateInput = (e) => {
            if (e.target.value.length > 0) {

            }
        };

        const submitHandler = async () => {

            errorMessages.value = [];
            const data = new FormData();
            if (userData.value.file !== null) {
                data.append('created_by', userData.value.owner_id);
                data.append('name', userData.value.name);
                data.append('email', userData.value.email + '@' + organziationDomain.value);
                data.append('role', userData.value.userRoles2);
                data.append('password_confirmation', userData.value.password_confirmation);
                data.append('password', userData.value.password);
                data.append('file', userData.value.file);
            } else {
                data.append('created_by', userData.value.owner_id);
                data.append('name', userData.value.name);
                data.append('email', userData.value.email + '@' + organziationDomain.value);
                data.append('password_confirmation', userData.value.password_confirmation);
                data.append('password', userData.value.password);
                data.append('role', userData.value.userRoles);
            }


            try {
                if (userData.value.file == null) {
                    if (userData.value.name === '') {
                        isErrorTag.value = true;
                        errors.value.isError = true;
                        errors.value['name'][0] = '*Required';
                    }
                    if (userData.value.email === '') {
                        isErrorTag.value = true;
                        errors.value.isError = true;
                        errors.value['email'][0] = '*Required';
                    }
                    if (userData.value.password == null) {
                        isErrorTag.value = true;
                        errors.value.isError = true;
                        console.log(errors.value.isError,"********")
                        errors.value['password'][0] = '*Required';
                    }
                    if (userData.value.password_confirmation == null) {
                        isErrorTag.value = true;
                        errors.value.isError = true;
                        errors.value['password_confirmation'][0] = '*Required';
                    }
                    if (userData.value.userRoles === null) {
                        showErrorModal.value = true;
                        responseErrorMessage.value = "Please Select a Role for Users";
                    }
                } else {
                    if (userData.value.userRoles2 === null) {
                        showErrorModal.value = true;
                        responseErrorMessage.value = "Please Select a Role for Users List";
                    }
                }

                if ((!errors.value.isError && userData.value.userRoles !== null) || (!errors.value.isError && userData.value.userRoles2 !== null)) {
                    isErrorTag.value = false;
                    const cretedUser = await User.saveUser(data);
                    let closeFileBtn = document.getElementsByClassName('filepond--action-remove-item');
                    closeFileBtn[0]?.click();
                    await store.dispatch('setSuccessModal', true);
                    await store.dispatch('setSueccessMessage', cretedUser.data.message);

                    userData.value.name = '';
                    userData.value.email = '';
                    userData.value.password = '';
                    userData.value.password_confirmation = '';
                    userData.value.userRoles = null;
                    userData.value.userRoles2 = null;
                    userData.value.file = null;

                    await store.dispatch('setDataFlag', false);
                    errors.value = {
                        name: [],
                        email: [],
                        password: '',
                        password_confirmation: '',
                        isError: false
                    };
                    setTimeout(async () => {
                        await router.push('/settings/user');
                    }, 2000);
                }
            } catch (e) {
                // console.log({e})
                if (e.response.data.errors) {
                    if (e.response.data.errors.name || e.response.data.errors.email) {
                        if (e.response.data.errors.name)
                            e.response.data.errors.name.forEach((err, idx) => {
                                errors.value['name'][idx] = `* ${err}`
                            });
                        if (e.response.data.errors.email)
                            e.response.data.errors.email.forEach((err, idx) => {
                                errors.value['email'][idx] = `* ${err}`
                            });
                    } else if (e.response.data.errors.file) {
                        errorMessages.value[0] = `* ${e.response.data.errors.file[0]}`;
                    } else {
                        let idx = 0;
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[1];
                            let record = property.split('.')[0]
                            errors.value[key][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                        }
                    }
                } else if (e.response.data) {
                    showErrorModal.value = true;
                    responseErrorMessage.value = e.response.data.message
                }
            }

        };

        const backHandler = async () => {
            let setDataFlag = store.state.settings.setDataFlag;
            if (setDataFlag) {
                isFull.value = true;
                await store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
            } else {
                await store.dispatch('setDataFlag', false);
                isFull.value = false
            }
        };

        const confirmModalHandler = async (event) => {
            isFull.value = false;
            await store.dispatch('setConfirmModal', false);
            if (event) {
                await store.dispatch('setDataFlag', false);
                await router.push('/settings/user');
            }
        };

        return {
            validateInput,
            fileRemove,
            fileUpload,
            roles,
            roles2,
            submitHandler,
            setData,
            isDownloaded,
            backBtn,
            changeHandler,
            showDefaultUser,
            hideDefaultUser,
            backHandler,
            confirmModalHandler,
            viewDocumentHandler,
            isData: computed(() => store.state.settings.setDataFlag),
            isFull,
            confirmModal: computed(() => store.state.settings.confirmModal),
            confirmMessage: computed(() => store.state.settings.confirmMessage),
            showModal,
            responseErrorMessage,
            showErrorModal,
            errorMessages,
            userData,
            organziationDomain,
            isErrorTag,
            errors
        }
    }
}
</script>

<style scoped>
.designDefaultUser {
    left: calc(100% + 40px);
    display: none;
    position: absolute;
    top: 40px;
    width: 100%;
    font-size: 12px;
    background-color: #021A24;
    color: #fff;
    padding: 0.8em;
    border-radius: 10px;
}

.styleDesignCircleInfo {
    cursor: pointer;
}

.styleDesignCircleInfo:hover {
    color: #e95626;
}

.divMultiSelect {
    position: relative;
}

.fontInfoData {
    /*display: flex; *!*/
    position: absolute;
    top: 40px;
    right: -28px;
}

.upload-container-none {
    pointer-events: none !important;
    opacity: 0.5;
}

.upload-container {
    pointer-events: auto;
    opacity: 1;
}

.checkPositionRelative {
    position: relative;
    top: 0px;
}

.input-group-text {
    color: var(--main-color);
    height: 36px;
    background-color: transparent;
}

.cssGap {
    gap: 20px;
}

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.errorValidation {
    position: absolute;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus {
    background-color: transparent;
    color: var(--main-color);
    width: 100%;
    height: 36px;
}

.custom-inputForEmail {
    background-color: transparent;
    color: var(--main-color);
    width: 100%;
    height: 36px;

}

.custom-inputForEmail:focus {
    background-color: #021A24;
    color: #fff;
}

#createUserContainer {
    padding: 20px;
    height: 70vh;
}


.upload-file {
    /*background-color: #021A24;*/
    /*border: 1px solid #6F8896;*/
    /*z-index: 0;*/
    /*width: 100%;*/
    /*border-radius: 15px;*/
    /*padding: 10%;*/
    /*overflow-y: auto;*/
    /*display: flex;*/
}

.upload-file2 {
    background-color: transparent;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.tabcontent {
    display: block;
    padding: 30px !important;
    height: 75vh;
    overflow-y: auto;
    background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
    border-radius: 3px;
    border: 1px solid var(--table-border);
}
</style>
